import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cn } from "@/lib/utils";
import { HistoryItem } from "./HistoryItem";

export function SortableHistoryItem({ thread, ...historyItemProps }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: thread.id,
    data: {
      type: "chat",
      item: thread,
      workspaceId: null, // Chats section threads don't have a workspace
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Prevent drag when clicking on interactive elements
  const handlePointerDown = (e) => {
    if (
      e.target.closest("button") ||
      e.target.closest("a") ||
      e.target.closest("[role='button']") ||
      e.target.closest(".dropdown-menu-item") ||
      e.target.closest(".thread-menu-trigger") ||
      e.target.closest("input") ||
      e.target.closest("textarea")
    ) {
      return;
    }
    if (listeners?.onPointerDown) {
      listeners.onPointerDown(e);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onPointerDown={handlePointerDown}
      className={cn(
        "w-full cursor-grab active:cursor-grabbing",
        isDragging && "opacity-50 z-50"
      )}
    >
      <HistoryItem thread={thread} {...historyItemProps} />
    </div>
  );
}
